import React, { useEffect, useState } from "react";
import { DamagedService } from "./core/_request";
import { Loader } from "../../../common/components/Loader/Loader";
import { HttpStatusCode } from "axios";
import { TitleHeader } from "../../../common/components/TitleHeader/TitleHeader";
import { Container } from "../../../common/components/container/Container";
import { TypeCard } from "../../../common/components/TypeCard/TypeCard";
import style from "./components/style.module.scss";
import { PiShippingContainerFill } from "react-icons/pi";
import { RiShipFill } from "react-icons/ri";
import { FaTruckFast } from "react-icons/fa6";
import { PiTeaBagBold } from "react-icons/pi";
import { LiaListUlSolid } from "react-icons/lia";
import { useSearchParams } from "react-router";
import { DamagedList } from "./components/DamagedList";
import { DamagedConstant } from "./core/_constant";

export const DamagedPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedType = searchParams.get("type");

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [damagedType, setDamagedType] = useState<Array<any>>([]);

  useEffect(() => {
    getDamagedType();
  }, []);

  const getDamagedType = async () => {
    try {
      setIsLoading(true);

      const res = await DamagedService.getAllLoadTypes();

      if (res?.status === HttpStatusCode.Ok) {
        setDamagedType(res?.data?.member);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onSelectTypeHandler = (id: string) => {
    setSearchParams({ type: id?.toLowerCase() });
  };

  const getIconHandler = (id: string) => {
    switch (id) {
      case DamagedConstant.AVARIE_TYPE.container:
        return (
          <PiShippingContainerFill
            style={{
              height: "40px",
              width: "40px",
            }}
          />
        );

      case DamagedConstant.AVARIE_TYPE.craft:
        return (
          <RiShipFill
            style={{
              height: "40px",
              width: "40px",
            }}
          />
        );

      case DamagedConstant.AVARIE_TYPE.vehicle:
        return (
          <FaTruckFast
            style={{
              height: "40px",
              width: "40px",
            }}
          />
        );

      case DamagedConstant.AVARIE_TYPE.bag:
        return (
          <PiTeaBagBold
            style={{
              height: "40px",
              width: "40px",
            }}
          />
        );

      case DamagedConstant.AVARIE_TYPE.other:
        return (
          <LiaListUlSolid
            style={{
              height: "40px",
              width: "40px",
            }}
          />
        );

      default:
        return (
          <PiShippingContainerFill
            style={{
              height: "40px",
              width: "40px",
            }}
          />
        );
    }
  };

  return (
    <div className="">
      {!selectedType ? (
        <div>
          <Loader isLoading={isLoading} />
          <div className="">
            <TitleHeader title="Avaries" />
          </div>

          <Container className={""}>
            <div className={style.avarie__container}>
              {damagedType?.map((item: any) => (
                <TypeCard
                  key={item?.id}
                  id={item?.id}
                  title={item?.name}
                  path={item?.id?.toLowerCase()}
                  onClick={onSelectTypeHandler}
                >
                  {getIconHandler(item?.id)}
                </TypeCard>
              ))}
            </div>
          </Container>
        </div>
      ) : (
        <DamagedList />
      )}
    </div>
  );
};
